import { AuthorInfo } from '@c/AuthorInfo';
import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import { BlogDocument } from '@util/types/firestore/blog';
import Link from 'next/link';

export const blogUrl = (slug: string) => `blog/${slug}`;

interface FeaturedBlogCardProps {
  blog: BlogDocument;
}

const FeaturedBlogCard = ({ blog }: FeaturedBlogCardProps) => {
  return (
    <div className="flex flex-col-reverse items-center gap-[2.4rem] sm:flex-row">
      {/* info */}
      <div className="max-w-[48.6rem] grow self-stretch ">
        <div className="flex w-full flex-col gap-[1.6rem] sm:gap-[2.4rem] sm:p-[2.4rem]">
          <div className="flex items-center">
            <FeaturedIcon />
            <span className="ml-[1.6rem] text-[1.8rem] font-semibold text-brand-primary">
              FEATURED
            </span>
          </div>
          {blog.tags.length > 0 && (
            <div className="  w-min whitespace-nowrap rounded-[5.6rem] bg-brand-primary-lighter px-[1.6rem] py-[0.6rem]  text-[1.3rem] font-semibold text-brand-primary">
              {blog.tags[0]}
            </div>
          )}
          <Link
            href={blogUrl(blog.slug)}
            className="text-[2.4rem] font-semibold leading-[2.4rem] sm:text-[3.2rem] sm:leading-[4.16rem]"
          >
            {blog.title}
          </Link>
          <div
            style={{
              lineHeight: '2.25rem',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {blog.description}
          </div>
          <AuthorInfo blog={blog} />

          <div className="max-w-[15.3rem]">
            <Button
              text="Read Article"
              type="secondary"
              href={blogUrl(blog.slug)}
            />
          </div>
        </div>
      </div>
      {/* image */}
      <Link
        href={blogUrl(blog.slug)}
        className="relative h-[22rem] w-full overflow-clip rounded-[0.6rem] sm:h-[42rem] lg:w-[68.8rem]"
      >
        <SafeImage
          alt={blog.title}
          src={blog.thumbnail}
          fill={true}
          style={{ objectFit: 'cover' }}
        />
        <div className="absolute bottom-[1.6rem] left-[1.6rem] rounded-[5.6rem] bg-brand-white-20 px-[1.6rem] py-[0.6rem] text-[1.3rem] font-semibold text-brand-white">
          {blog.tags[0]}
        </div>
      </Link>
    </div>
  );
};

const FeaturedIcon = () => (
  <svg
    width="24"
    height="37"
    viewBox="0 0 24 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 36.5V0.5H24V36.5L12 30.5L0 36.5Z" fill="#C41719" />
    <path
      d="M13.7496 14.0608L12 8.30078L10.2504 14.0608H4.80005L9.24965 17.236L7.55765 22.7008L12 19.324L16.4496 22.7008L14.7576 17.236L19.2 14.0608H13.7496Z"
      fill="white"
    />
  </svg>
);
export default FeaturedBlogCard;
